
import { supabase } from '@/integrations/supabase/client';
import { StoreEmployee } from '@/models/storeModel';
import { v4 as uuidv4 } from 'uuid';

// Log employee updates
export const logEmployeeUpdated = async (
  employeeId: string,
  storeId: string,
  changes: Record<string, [string | number | boolean, string | number | boolean]>
): Promise<void> => {
  try {
    // Get current authenticated user
    const { data: { user } } = await supabase.auth.getUser();
    
    // Create activity log
    await supabase
      .from('activity_logs')
      .insert({
        id: uuidv4(),
        entity_type: 'employee',
        entity_id: employeeId,
        store_id: storeId,
        user_id: user?.id,
        user_name: user ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}` : 'System',
        action: 'updated',
        details: { changes }
      });
  } catch (error) {
    console.error("Error logging employee update:", error);
    // We don't throw here to prevent the main operation from failing
  }
};

// Log employee deletion
export const logEmployeeDeleted = async (
  employeeId: string,
  storeId: string,
  employeeInfo: {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
  }
): Promise<void> => {
  try {
    // Get current authenticated user
    const { data: { user } } = await supabase.auth.getUser();
    
    // Create activity log
    await supabase
      .from('activity_logs')
      .insert({
        id: uuidv4(),
        entity_type: 'employee',
        entity_id: employeeId,
        store_id: storeId,
        user_id: user?.id,
        user_name: user ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}` : 'System',
        action: 'deleted',
        details: employeeInfo
      });
  } catch (error) {
    console.error("Error logging employee deletion:", error);
    // We don't throw here to prevent the main operation from failing
  }
};
